import { Ionicons } from "@expo/vector-icons";
import { Link } from "expo-router";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pressable, ScrollView, View } from "react-native";
import Animated, { FadeInRight } from "react-native-reanimated";

import Title from "@/components/Title";
import AssetSelected from "@/components/forms/AssetSelected";
import BankInformation from "@/components/forms/external_accounts/BankInformation";
import Profile from "@/components/forms/external_accounts/Profile";
import SelectRail from "@/components/forms/external_accounts/SelectRail";
import Stepper from "@/components/forms/external_accounts/Stepper";
import { sendRequest } from "@/utils/ApiUtil";

interface ExternalAccountData {
  beneficiaryName?: string;
  accountOwnerType?: string;
  country?: string;
  state?: string;
  city?: string;
  addressLine1?: string;
  postalCode?: string;
  postalCodeUs?: string;
  rail?: string;
  accountNumber?: string;
  routingNumber?: string;
  bankName?: string;
  accountType?: string;
  bic?: string;
  bankCountry?: string;
}

export default function Transfer() {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [requestData, setRequestData] = useState<ExternalAccountData>(
    {} as ExternalAccountData,
  );

  const setFormValues = (data: ExternalAccountData) => {
    setRequestData({ ...requestData, ...data });
    setCurrentStep(currentStep + 1);
  };

  return (
    <ScrollView contentContainerClassName="flex-grow items-center justify-center bg-white1 p-4 lg:p-0">
      <View className="w-full items-center justify-between px-6 flex-row">
        <Pressable
          onPress={() => setCurrentStep(currentStep <= 0 ? 0 : currentStep - 1)}
        >
          <Ionicons name="chevron-back-outline" size={24} color="#BDBDBD" />
        </Pressable>
        <Link href="/home" asChild>
          <View className="">
            <Ionicons name="close-outline" size={32} color="#BDBDBD" />
          </View>
        </Link>
      </View>
      <View className="w-full items-center my-2 gap-2">
        <Title text={t("home/web3/transfer:title")} />
      </View>
      <View className="my-4">
        <AssetSelected />
      </View>
      <Animated.View className="flex-grow w-full items-center gap-2">
        {currentStep > 0 && (
          <View className="my-2">
            <Stepper currentStep={currentStep} />
          </View>
        )}
        {currentStep === 0 && (
          <Animated.View className="mt-2" entering={FadeInRight}>
            <SelectRail
              sendData={(data) => {
                setCurrentStep(currentStep + 1);
              }}
            />
          </Animated.View>
        )}
        {currentStep === 1 && (
          <Animated.View entering={FadeInRight}>
            <Profile
              sendData={(data) => {
                setFormValues(data);
                setCurrentStep(currentStep + 1);
              }}
            />
          </Animated.View>
        )}
        {currentStep === 2 && (
          <Animated.View entering={FadeInRight}>
            <BankInformation
              sendData={(data) => {
                setFormValues(data);
              }}
            />
          </Animated.View>
        )}
      </Animated.View>
    </ScrollView>
  );
}
